import React from 'react';

const AttorneyIcon = ({ size = 16, fill = '#55458E' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.93496 3.34619C2.51266 3.21158 2.28643 2.77648 2.4272 2.37263C2.56797 1.96879 3.02294 1.75244 3.44524 1.88706L6.28568 2.79331C6.63256 2.226 7.27858 1.84619 8.01508 1.84619C9.12612 1.84619 10.026 2.70677 10.026 3.76927C10.026 3.84138 10.021 3.9111 10.0134 3.98081L13.0952 4.96398C13.5175 5.0986 13.7437 5.53369 13.603 5.93754C13.4622 6.34138 13.0072 6.55773 12.5849 6.42311L9.18142 5.33658C9.06831 5.4135 8.94765 5.4784 8.81945 5.53369V13.3847C8.81945 13.8101 8.46 14.1539 8.01508 14.1539H3.18884C2.74392 14.1539 2.38447 13.8101 2.38447 13.3847C2.38447 12.9592 2.74392 12.6154 3.18884 12.6154H7.21071V5.53129C6.68284 5.31013 6.27562 4.88225 6.09967 4.3534L2.93496 3.34379V3.34619ZM5.00874 8.76927L3.18884 5.78369L1.36895 8.76927H5.00874ZM3.18884 11.077C1.60774 11.077 0.293097 10.2597 0.0216206 9.18033C-0.0437348 8.9159 0.0467572 8.64427 0.190036 8.40869L2.58305 4.48561C2.70873 4.27888 2.93999 4.15388 3.18884 4.15388C3.43769 4.15388 3.66895 4.28129 3.79463 4.48561L6.18764 8.40869C6.33092 8.64427 6.42142 8.9159 6.35606 9.18033C6.08459 10.2597 4.76994 11.077 3.18884 11.077ZM12.8112 8.86061L10.9913 11.8462H14.6336L12.8112 8.86061ZM15.9784 12.2572C15.7069 13.3366 14.3923 14.1539 12.8112 14.1539C11.2301 14.1539 9.91541 13.3366 9.64394 12.2572C9.57858 11.9928 9.66907 11.7212 9.81235 11.4856L12.2054 7.56254C12.331 7.35581 12.5623 7.23081 12.8112 7.23081C13.06 7.23081 13.2913 7.35821 13.417 7.56254L15.81 11.4856C15.9532 11.7212 16.0437 11.9928 15.9784 12.2572Z"
        fill={fill}
      />
    </svg>
  );
};

export default AttorneyIcon;

